import { createUseStyles } from 'react-jss';

export default createUseStyles({
  container: {
    overflowX: 'auto'
  },
  table: {
    width: '100%',
    backgroundColor: 'white',
    marginBottom: '56px',
  },

  tableHeader: {
    borderBottom: '1px solid #F3F6F9',

    '& th': {
      padding: '25px',
      color: '#102131',
      fontSize: '16px',
      fontWeight: '600',
    },
  },

  tableBody: {
    '& td': {
      padding: '20px 25px',
      color: '#6D7883',
      fontSize: '16px',
    },
    '& tr:last-of-type td': {
      padding: '20px 25px 42px',
    },
  },

  btnGroup: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    '& > *:first-child': {
      marginRight: '24px',
    },
    '@media(max-width: 900px)': {
      width: 'auto',
    },
    
  },

  listContainer: {
    marginTop: '50px',
    fontSize: '16px',
  },
  simpleItem: {
    marginTop: '10px',
    border: '1px solid #F3F6F9',
    borderRadius: '10px',
    color: '#6D7883',
    backgroundColor: 'white',
    cursor: 'pointer'
  },
  primaryText: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '16px',
  },
  secondaryText: {
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: '12px',
    padding: '0px 16px 16px',
  },
  campaignName: {
    fontFamily: '"Manrope", sans-serif',
    fontSize: '20px',
    fontWeight: '600',
    marginRight: '20px',
  },
  datesWrapper: {
    display: 'flex',
    flexDirection: 'column',
    marginRight: '20px',
  },
  beginDate: {
    color: 'green'
  },
  endDate: {
    color: 'red'
  }
});
